export const TipoProveedorOAuthEnum = {
  CREDENCIAL: 1,
  FACEBOOK: 2,
  GOOGLE: 3,
  APPLE: 4,
  MICROSOFT: 5,
} as const;

export const TIPO_PROVEEDOR_OAUTH_NAME: Record<TipoProveedorOauth, string> = {
  [TipoProveedorOAuthEnum.CREDENCIAL]: 'Credencial',
  [TipoProveedorOAuthEnum.FACEBOOK]: 'Facebook',
  [TipoProveedorOAuthEnum.GOOGLE]: 'Google',
  [TipoProveedorOAuthEnum.APPLE]: 'Apple',
  [TipoProveedorOAuthEnum.MICROSOFT]: 'Microsoft',
} as const;

export type TipoProveedorOauth =
  (typeof TipoProveedorOAuthEnum)[keyof typeof TipoProveedorOAuthEnum];
